<template>
  <div id="app" :class="{'mobile': isMobile, 'no-scroll': showHotLine}">
    <page-header @showHotLine="showHotLine = true"></page-header>
    <banner></banner>
    <service-item @showHotLine="showHotLine = true"></service-item>
    <page-footer @showHotLine="showHotLine = true"></page-footer>
    <hot-line :show="showHotLine" @hideHotLine="showHotLine = false" @click.native="showHotLine = false"></hot-line>
  </div>
</template>

<script>
import pageHeader from './components/page-header'
import banner from './components/banner'
import serviceItem from './components/service-item'
import hotLine from './components/hot-line'
import pageFooter from './components/page-footer'
export default {
  name: 'app',
  components: {
    pageHeader,
    banner,
    serviceItem,
    hotLine,
    pageFooter
  },
  data () {
    return {
      isMobile: true,
      showHotLine: false
    }
  },
  created () {
    this.isMobile = navigator.userAgent.includes('Mobile')
  }
}
</script>

<style lang="scss">
  html,body{
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  body{
    background-image: url("assets/images/it-shadow-bg.png"), url("assets/images/html_bg.jpg");
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #171300;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    &.no-scroll{
      overflow-y: hidden;
    }
  }
  .bg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
  }
</style>
